//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CalculationSetting } from "./calculation-setting";
import { ICalculationSettingWithTerms } from "./i-calculation-setting-with-terms";

export class Operation extends CalculationSetting implements ICalculationSettingWithTerms {
    operator?: string;
    id?: string;
    terms?: CalculationSetting[];
}
